import axios from "axios";
import { del, get, post, patch,  put } from "./feature_file_types_api_helper";
import * as url from "./feature_file_types_url_helper";





// Get features
export const getFeatureFileTypes = () => get(url.GET_FEATURE_FILE_TYPES);


// Add feature
//export const addNewFeature = feature => post(url.ADD_NEW_ACTION, feature);
//export const addNewBranch = branch => post(url.ADD_NEW_BRANCH, JSON.stringify(branch));

export const addNewFeatureFileType = (featureFileType) => post(url.ADD_NEW_FEATURE_FILE_TYPE, featureFileType);



// update feature
//export const updateFeature = feature => put(url.UPDATE_ACTION, feature);
export const updateFeatureFileType = (featureFileType) => patch(`${url.UPDATE_FEATURE_FILE_TYPE}/${featureFileType.id}`,  featureFileType);


// delete series categories
//export const deleteFeature = feature => del(url.DELETE_ACTION, { headers: { feature } });
export const deleteFeatureFileType = (featureFileType) => del(`${url.DELETE_FEATURE_FILE_TYPE}/${featureFileType.id}`);







export {
  //getLoggedInUser,
  
  
};
